import { createFileRoute } from "@tanstack/react-router";
import MultilingualNotaryLanding from "@/components/MultilingualNotaryLanding";
import { getNotaryLocale, NOTARY_HREFLANG_ALTS } from "@/data/notary-i18n";
import { multiHreflangLinks, SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";
import { notaryHowToSchema, notarySpeakableSchema } from "@/lib/notary-schema";

const L = getNotaryLocale("pt")!;

export const Route = createFileRoute("/pt/notary")({
  head: () => ({
    meta: [
      { title: ctaTitle(L.title, "/pt/notary", "th")},
      { name: "description", content: ctaDesc(L.description, "/pt/notary", "th")},
      { property: "og:title", content: ctaTitle(L.title, "/pt/notary", "th")},
      { property: "og:description", content: ctaDesc(L.description, "/pt/notary", "th")},
      { property: "og:url", content: `${SEO_SITE}${L.path}` },
      { property: "og:locale", content: "pt_PT" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${L.path}` },
      ...multiHreflangLinks(NOTARY_HREFLANG_ALTS, "/notary"),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "LegalService",
        name: "NYC Legal — Notário Público em Banguecoque", url: `${SEO_SITE}${L.path}`,
        areaServed: "TH", inLanguage: "pt", priceRange: "฿500–฿5,000",
        serviceType: "Notarial Services Attorney",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "pt",
        mainEntity: L.faqs.map((f) => ({
          "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }) },
      notaryHowToSchema({ url: `${SEO_SITE}${L.path}`, name: L.stepsH2, inLanguage: "pt", steps: L.steps }),
      notarySpeakableSchema(`${SEO_SITE}${L.path}`),
    ],
  }),
  component: () => <MultilingualNotaryLanding l={L} />,
});
